import {
  ACTIONS,
  build,
  buildMany,
  ROLES,
} from '../shared/permission-matrix/permission-builder';

// permissionConstants.ts
export const Permission = {
  DASHBOARD: [
    'portal.web.tamiin.insuree.dashboard',
    'portal.web.tamiin.provider.dashboard',
    'portal.web.tamiin.hmo.dashboard',
    'portal.web.tamiin.payer.dashboard',
    'portal.web.tamiin.super_admin.dashboard',
    'portal.web.tamiin.hmo.dashboard/view',
    'portal.web.tamiin.superadmin.dashboard/view',
    'portal.web.tamiin.provider.dashboard/view',
    'portal.web.tamiin.payer.dashboard/view',

    'portal.web.tamiin.nhia.dashboard',
    'portal.web.tamiin.nhia.dashboard/view',

  ],

  ADMINISTRATION: [
    // ========================
    // BASE ROUTES
    // ========================
    `portal.web.tamiin.${ROLES.SUPER_ADMIN}.user-management`,
    `portal.web.tamiin.${ROLES.HMO}.user-management`,
    `portal.web.tamiin.${ROLES.PROVIDER}.user-management`,
    `portal.web.tamiin.${ROLES.NHIA}.user-management`,

     `portal.web.tamiin.${ROLES.SUPERADMIN}.role-management`,
  `portal.web.tamiin.${ROLES.HMO}.role-management`,
  `portal.web.tamiin.${ROLES.PROVIDER}.role-management`,
  `portal.web.tamiin.${ROLES.NHIA}.role-management`,
  


    ...build(ROLES.HMO, 'administration', 'user-management', ACTIONS.user),
    ...build(ROLES.PROVIDER, 'administration', 'user-management', ACTIONS.user),
    ...build(
      ROLES.SUPERADMIN,
      'administration',
      'user-management',
      ACTIONS.user,
    ),
    ...build(
      ROLES.NHIA,
      'administration',
      'user-management',
      ACTIONS.user,
    ),

    // ========================
    // SUPERADMIN - ROLE PERMISSION
    // ========================
    ...build(ROLES.SUPERADMIN, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
      'delete',
    ]),

    // ========================
    // SUPERADMIN - PERMISSION MANAGEMENT
    // ========================
    ...build(ROLES.SUPERADMIN, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),

    // ========================
    // HMO - ROLE PERMISSION
    // ========================
    ...build(ROLES.HMO, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
    ]),

     ...build(ROLES.NHIA, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
    ]),

    // ========================
    // HMO - PERMISSION MANAGEMENT
    // ========================
    ...build(ROLES.HMO, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),

    // ========================
    // PROVIDER - ROLE PERMISSION
    // ========================
    ...build(ROLES.PROVIDER, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'delete',
    ]),

    // ========================
    // PROVIDER - PERMISSION MANAGEMENT
    // ========================
    ...build(ROLES.PROVIDER, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),

    // ========================
     ...build(ROLES.NHIA, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),
  ],
  USER_MANAGEMENT: [
    // ========================
    // BASE ROUTES
    // ========================
    `portal.web.tamiin.${ROLES.SUPER_ADMIN}.user-management`,
    `portal.web.tamiin.${ROLES.HMO}.user-management`,
    `portal.web.tamiin.${ROLES.PROVIDER}.user-management`,
    `portal.web.tamiin.${ROLES.NHIA}.user-management`,
    ...build(ROLES.HMO, 'administration', 'user-management', ACTIONS.user),
    ...build(ROLES.PROVIDER, 'administration', 'user-management', ACTIONS.user),
    ...build(
      ROLES.SUPERADMIN,
      'administration',
      'user-management',
      ACTIONS.user,
    ),
    ...build(
      ROLES.NHIA,
      'administration',
      'user-management',
      ACTIONS.user,
    ),
  ],
  ROLE_MANAGEMENT: [
    `portal.web.tamiin.${ROLES.SUPER_ADMIN}.role-management`,
    `portal.web.tamiin.${ROLES.HMO}.role-management`,
    `portal.web.tamiin.${ROLES.PAYER}.role-management`,
    `portal.web.tamiin.${ROLES.PROVIDER}.role-management`,
    `portal.web.tamiin.${ROLES.NHIA}.role-management`,

    // ========================
    // SUPERADMIN - ROLE PERMISSION
    // ========================
    ...build(ROLES.SUPERADMIN, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
    ]),
    // ========================
    // HMO - ROLE PERMISSION
    // ========================
    ...build(ROLES.HMO, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
    ]),

    // ========================
    // PROVIDER - ROLE PERMISSION
    // ========================
    ...build(ROLES.PROVIDER, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
    ]),
    // ========================
    // NHIA - ROLE PERMISSION
    // ========================
    ...build(ROLES.NHIA, 'administration', 'role-permission', [
      'view',
      'create',
      'edit',
      'assign-permissions',
    ]),
  ],

  PERMISSION_MANAGEMENT: [
    `portal.web.tamiin.${ROLES.SUPER_ADMIN}.permission-management`,
    `portal.web.tamiin.${ROLES.HMO}.permission-management`,
    `portal.web.tamiin.${ROLES.PROVIDER}.permission-management`,
    `portal.web.tamiin.${ROLES.PAYER}.permission-management`,
      `portal.web.tamiin.${ROLES.NHIA}.permission-management`,

    `portal.web.tamiin.${ROLES.SUPER_ADMIN}.role-management`,
    `portal.web.tamiin.${ROLES.HMO}.role-management`,
    `portal.web.tamiin.${ROLES.PAYER}.role-management`,
    `portal.web.tamiin.${ROLES.PROVIDER}.role-management`,
    `portal.web.tamiin.${ROLES.NHIA}.role-management`, "",

    // ========================
    // SUPERADMIN - PERMISSION MANAGEMENT
    // ========================
    ...build(ROLES.SUPERADMIN, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),
    // ========================
    // HMO - PERMISSION MANAGEMENT
    // ========================
    ...build(ROLES.HMO, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),

    // ========================
    // PROVIDER - PERMISSION MANAGEMENT
    // ========================
    ...build(ROLES.PROVIDER, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),
    // ========================
      ...build(ROLES.NHIA, 'administration', 'permission-management', [
      'view',
      'create',
      'edit',
      'delete',
    ]),
  ],
  BILLING_PAYMENT: [
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments',
    'portal.web.tamiin.hmo.billing-payment/refunds-adjustments',
    'portal.web.tamiin.hmo.billing-payment/premium-contributions',
    'portal.web.tamiin.provider.billing-payment/claims-financing-provider-payments',
    'portal.web.tamiin.provider.billing-payment/refunds-adjustments',
    'portal.web.tamiin.provider.billing-payment/premium-contributions',
    'portal.web.tamiin.super_admin.billing-payment/premium-contributions',
    'portal.web.tamiin.super_admin.billing-payment/claims-financing-provider-payments',
    'portal.web.tamiin.super_admin.billing-payment/refunds-adjustments',
    

    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-schemas/view',
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-cycles/view',
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-batches/view',
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-payments/view',

    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/claims-payables/view',
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/provider-payment-batches/view',
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/provider-settlements/view',
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/reversals-adjustments/view',

    'portal.web.tamiin.hmo.billing-payment/refunds-adjustments/view',


     `portal.web.tamiin.${ROLES.NHIA}.billing-payment`,
  `portal.web.tamiin.${ROLES.NHIA}.billing-payment/claims-financing-provider-payments`,
  `portal.web.tamiin.${ROLES.NHIA}.billing-payment/premium-contributions`,
  `portal.web.tamiin.${ROLES.NHIA}.billing-payment/refunds-adjustments`,

  // ========================
  // CAPITATION
  // ========================
  ...buildMany(ROLES.NHIA, 'billing-payment', [
    'capitation/capitation-schemas',
    'capitation/capitation-batches',
    'capitation/capitation-cycles',
    'capitation/capitation-payments',
  ], ['view']),

  // ========================
  // CLAIMS FINANCING / PROVIDER PAYMENTS
  // ========================
  ...buildMany(ROLES.NHIA, 'billing-payment', [
    'claims-financing-provider-payments/provider-settlements',
    'claims-financing-provider-payments/claims-payables',
    'claims-financing-provider-payments/reversals-adjustments',
  ], ['view']),

  ...buildMany(ROLES.NHIA, 'premiums-payment', [
    'premium-contribution/contribution',
    'premium-contribution/premium-schema',
    'premium-contribution/premium-payments',
  ], ['view']),

   ...buildMany(ROLES.NHIA, 'premiums-payment', [
    'premium-contribution/employer-contributions',
  ], [
    'upload-payroll',
    'employees',
    'record-payment',
    'reminder',
  ]),
  ],
  PAYMENT_CLAIMS_FINANCING: [
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments',
    'portal.web.tamiin.provider.billing-payment/claims-financing-provider-payments',
    'portal.web.tamiin.super_admin.billing-payment/claims-financing-provider-payments',

    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/claims-payables/view',
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/provider-payment-batches/view',
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/provider-settlements/view',
    'portal.web.tamiin.hmo.billing-payment/claims-financing-provider-payments/reversals-adjustments/view',
 ...buildMany(ROLES.NHIA, 'billing-payment', [
    'claims-financing-provider-payments/provider-settlements',
    'claims-financing-provider-payments/claims-payables',
    'claims-financing-provider-payments/reversals-adjustments',
  ], ['view']),

  ],
  CAPITATION_PAYMENT: [
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-schemas/view',
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-cycles/view',
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-batches/view',
    'portal.web.tamiin.hmo.billing-payment/capitation/capitation-payments/view',
   ...buildMany(ROLES.NHIA, 'billing-payment', [
    'capitation/capitation-schemas',
    'capitation/capitation-batches',
    'capitation/capitation-cycles',
    'capitation/capitation-payments',
  ], ['view']),
  ],
  REFUNDS_ADJUSTMENTS: [
    'portal.web.tamiin.hmo.billing-payment/refunds-adjustments',
    'portal.web.tamiin.provider.billing-payment/refunds-adjustments',
    'portal.web.tamiin.super_admin.billing-payment/refunds-adjustments',
      `portal.web.tamiin.${ROLES.NHIA}.billing-payment/refunds-adjustments`,

    'portal.web.tamiin.hmo.billing-payment/refunds-adjustments/view',
    'portal.web.tamiin.nhia.billing-payment/refunds-adjustments/view',



  ],
  PREMIUM_CONTRIBUTIONS: [
    'portal.web.tamiin.hmo.billing-payment/premium-contributions',
    'portal.web.tamiin.provider.billing-payment/premium-contributions',
    'portal.web.tamiin.super_admin.billing-payment/premium-contributions',
  `portal.web.tamiin.${ROLES.NHIA}.billing-payment/premium-contributions`,

    ...buildMany(ROLES.NHIA, 'premiums-payment', [
    'premium-contribution/contribution',
    'premium-contribution/premium-schema',
    'premium-contribution/premium-payments',
  ], ['view']),

   ...buildMany(ROLES.NHIA, 'premiums-payment', [
    'premium-contribution/employer-contributions',
  ], [
    'upload-payroll',
    'employees',
    'record-payment',
    'reminder',
  ]),
  ],

  CONTRIBUTIONS_BILLING: [
    'portal.web.tamiin.payer.employer-group-management/contribution-billing',
  ],

  ENCOUNTER_REFERRAL: [
    'portal.web.tamiin.insuree.encounter-referral/encounters-referrals',
  ],
  FEEDBACK: [
    'portal.web.tamiin.insuree.feedback',
    'portal.web.tamiin.hmo.feedback',
  ],

  MASTER: [
    'portal.web.tamiin.hmo.master/manage-health-services',
    'portal.web.tamiin.hmo.master/manage-health-plans',
    'portal.web.tamiin.super_admin.master/manage-health-services',
    'portal.web.tamiin.super_admin.master/manage-health-plans',
  ],
  MANAGE_HEALTH_PLAN: [
    'portal.web.tamiin.hmo.master/manage-health-plans',
    'portal.web.tamiin.super_admin.master/manage-health-plans',
  ],
  MANAGE_HEALTH_SERVICE: [
    'portal.web.tamiin.hmo.master/manage-health-services',
    'portal.web.tamiin.super_admin.master/manage-health-services',
  ],

  SYSTEM_CONFIGURATION: ['portal.web.tamiin.super_admin.system-configuration'],
  SUBSCRIPTION_MANAGEMENT: [
    'portal.web.tamiin.super_admin.subscription-management',
  ],
  REPORT_ANALYTICS: ['portal.web.tamiin.super_admin.reports-analytics'],
  AUDIT_ACTIVITY: [
    'portal.web.tamiin.payer.audit-activity',
    'portal.web.tamiin.super_admin.audit-activity',
  ],

  ACCREDITATION: [
    'portal.web.tamiin.hmo.accreditation',
    'portal.web.tamiin.super_admin.accreditation',
    'portal.web.tamiin.nhia.accreditation',

    'portal.web.tamiin.hmo.provider/accreditation/view',
    'portal.web.tamiin.superadmin.provider/accreditation/view',
    'portal.web.tamiin.nhia.provider/accreditation/view',

  ],
  ACCREDITATION_STATUS: [
    'portal.web.tamiin.provider.provider-management/accreditation-status',
  ],

  ELIGIBILITY_CHECK: [
    'portal.web.tamiin.provider.provider-management/eligibility-check',
  ],
  PRE_AUTHORIZATION: [
    'portal.web.tamiin.provider.provider-management/pre-authorization',
  ],
  ENROLLES_MANAGEMENT: [
    'portal.web.tamiin.hmo.enrollees-management/bhcpf',
    'portal.web.tamiin.hmo.enrollees-management/formal',
    'portal.web.tamiin.hmo.enrollees-management/dependents',
    'portal.web.tamiin.hmo.enrollees-management/program-provider',
    'portal.web.tamiin.hmo.enrollees-management/vgp',
    'portal.web.tamiin.hmo.enrollees-management/self-enrollment',
    'portal.web.tamiin.hmo.enrollees-management/informal',
    'portal.web.tamiin.insuree.enrollment-management/my-dependents',
    'portal.web.tamiin.hmo.enrollees-management/gifship',
    'portal.web.tamiin.hmo.enrollees-management/membership-synchronization',


      `portal.web.tamiin.${ROLES.NHIA}.enrollees-management`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/formal`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/informal`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/dependents`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/vgp`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/bhcpf`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/program-provider`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/membership-synchronization`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/self-enrollment`,

     // ========================
  // PRIVATE ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'private-enrollee/private-enrollee-family',
    'private-enrollee/private-enrollee-individual',
    'private-enrollee/private-enrollee-corporate',
    'private-enrollee/private-enrollee-sme-group',
    'private-enrollee/private-enrollee-special',
  ], ACTIONS.view), 
...buildMany(ROLES.NHIA, 'beneficiary', [
    'private-enrollee/private-enrollee-family',
    'private-enrollee/private-enrollee-individual',
    'private-enrollee/private-enrollee-corporate',
    'private-enrollee/private-enrollee-sme-group',
    'private-enrollee/private-enrollee-special',
  ], ACTIONS.view),


  // ========================
  // FORMAL ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'formal-enrollee/formal-enrollee-principal',
    'formal-enrollee/formal-enrollee-dependent',
  ], ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'beneficiary', [
    'formal-enrollee/formal-enrollee-principal',
    'formal-enrollee/formal-enrollee-dependent',
  ], ACTIONS.view),


  // ========================
  // INFORMAL ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'informal-enrollee/informal-enrollee-principal',
    'informal-enrollee/informal-enrollee-dependent',
  ], ACTIONS.view),
...buildMany(ROLES.NHIA, 'beneficiary', [
    'informal-enrollee/informal-enrollee-principal',
    'informal-enrollee/informal-enrollee-dependent',
  ], ACTIONS.view),
  // ========================
  // GIFSHIP ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'gifship-enrollee/gifship-enrollee-individual',
    'gifship-enrollee/gifship-enrollee-family',
    'gifship-enrollee/gifship-enrollee-group',
  ], ACTIONS.view), 
 ...buildMany(ROLES.NHIA, 'beneficiary', [
    'gifship-enrollee/gifship-enrollee-individual',
    'gifship-enrollee/gifship-enrollee-family',
    'gifship-enrollee/gifship-enrollee-group',
  ], ACTIONS.view), 
  // ========================
  // VGP ENROLLEE
  // ========================
    ...buildMany(ROLES.HMO, 'beneficiary', [
      'vgp-enrollee/vgp-enrollee-children',
      'vgp-enrollee/vgp-enrollee-elderly',
      'vgp-enrollee/vgp-enrollee-pregnant-women',
      'vgp-enrollee/vgp-enrollee-pwd',
    ], ACTIONS.view),
     ...buildMany(ROLES.NHIA, 'beneficiary', [
      'vgp-enrollee/vgp-enrollee-children',
      'vgp-enrollee/vgp-enrollee-elderly',
      'vgp-enrollee/vgp-enrollee-pregnant-women',
      'vgp-enrollee/vgp-enrollee-pwd',
    ], ACTIONS.view),

  // ========================
  // SINGLE TYPES
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'bhcpf-enrollee',
    'self-enrollee',
    'dependent-enrollee',
    'employer-group',
  ], ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'beneficiary', [
    'bhcpf-enrollee',
    'self-enrollee',
    'dependent-enrollee',
    'employer-group',
  ], ACTIONS.view),

  // ========================
  // PROGRAM PROVIDER
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'program-provider/program-provider-suspensions',
    'program-provider/program-provider-transfers',
    'program-provider/program-provider-changes',
    'program-provider/program-provider-deregistrations',
  ], ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'beneficiary', [
    'program-provider/program-provider-suspensions',
    'program-provider/program-provider-transfers',
    'program-provider/program-provider-changes',
    'program-provider/program-provider-deregistrations',
  ], ACTIONS.view),
   ...buildMany(ROLES.HMO, 'beneficiary', [
    'membership-synchronization',
  ], ACTIONS.view),

  ],
  PRIVATE_SCHEME: ['portal.web.tamiin.hmo.enrollees-management/private-scheme',
 'portal.web.tamiin.hmo.enrollees-management/bhcpf',
    'portal.web.tamiin.hmo.enrollees-management/formal',
    'portal.web.tamiin.hmo.enrollees-management/dependents',
    'portal.web.tamiin.hmo.enrollees-management/program-provider',
    'portal.web.tamiin.hmo.enrollees-management/vgp',
    'portal.web.tamiin.hmo.enrollees-management/self-enrollment',
    'portal.web.tamiin.hmo.enrollees-management/informal',
    'portal.web.tamiin.insuree.enrollment-management/my-dependents',
    'portal.web.tamiin.hmo.enrollees-management/gifship',

      `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/private-scheme`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/formal`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/informal`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/dependents`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/vgp`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/bhcpf`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/program-provider`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/self-enrollment`,
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/membership-synchronization`,

     // ========================
  // PRIVATE ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'private-enrollee/private-enrollee-family',
    'private-enrollee/private-enrollee-individual',
    'private-enrollee/private-enrollee-corporate',
    'private-enrollee/private-enrollee-sme-group',
    'private-enrollee/private-enrollee-special',
  ], ACTIONS.view),

  ...buildMany(ROLES.NHIA, 'beneficiary', [
    'private-enrollee/private-enrollee-family',
    'private-enrollee/private-enrollee-individual',
    'private-enrollee/private-enrollee-corporate',
    'private-enrollee/private-enrollee-sme-group',
    'private-enrollee/private-enrollee-special',
  ], ACTIONS.view),
  ],
  BHCPF: ['portal.web.tamiin.hmo.enrollees-management/bhcpf',
    
  'portal.web.tamiin.hmo.beneficiary/bhcpf-enrollee/view',
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/bhcpf`,
  'portal.web.tamiin.nhia.beneficiary/bhcpf-enrollee/view',
  

  ],
  FORMAL: [
    'portal.web.tamiin.hmo.enrollees-management/formal',
  `portal.web.tamiin.${ROLES.NHIA}.enrollees-management/formal`,

     // ========================
  // FORMAL ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'formal-enrollee/formal-enrollee-principal',
    'formal-enrollee/formal-enrollee-dependent',
  ], ACTIONS.view),
   ...buildMany(ROLES.NHIA, 'beneficiary', [
    'formal-enrollee/formal-enrollee-principal',
    'formal-enrollee/formal-enrollee-dependent',
  ], ACTIONS.view),
  ],
  DEPENDENTS: [
    'portal.web.tamiin.hmo.enrollees-management/dependents',
    'portal.web.tamiin.nhia.enrollees-management/dependents',
    'portal.web.tamiin.hmo.beneficiary/dependent-enrollee/view',
    'portal.web.tamiin.nhia.beneficiary/dependent-enrollee/view',
  ],
  PROGRAM_PROVIDER: [
    'portal.web.tamiin.hmo.enrollees-management/program-provider',
    'portal.web.tamiin.nhia.enrollees-management/program-provider',
     ...buildMany(ROLES.HMO, 'beneficiary', [
    'program-provider/program-provider-suspensions',
    'program-provider/program-provider-transfers',
    'program-provider/program-provider-changes',
    'program-provider/program-provider-deregistrations',
  ], ACTIONS.view),
   ...buildMany(ROLES.NHIA, 'beneficiary', [
    'program-provider/program-provider-suspensions',
    'program-provider/program-provider-transfers',
    'program-provider/program-provider-changes',
    'program-provider/program-provider-deregistrations',
  ], ACTIONS.view),
  ],
  VGP: [
    'portal.web.tamiin.hmo.enrollees-management/vgp', 
    'portal.web.tamiin.nhia.enrollees-management/vgp', 

     // ========================
  // VGP ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'vgp-enrollee/vgp-enrollee-children',
    'vgp-enrollee/vgp-enrollee-elderly',
    'vgp-enrollee/vgp-enrollee-pregnant-women',
    'vgp-enrollee/vgp-enrollee-pwd',
  ], ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'beneficiary', [
    'vgp-enrollee/vgp-enrollee-children',
    'vgp-enrollee/vgp-enrollee-elderly',
    'vgp-enrollee/vgp-enrollee-pregnant-women',
    'vgp-enrollee/vgp-enrollee-pwd',
  ], ACTIONS.view),
  ],
  GIFSHIP: [
    'portal.web.tamiin.hmo.enrollees-management/gifship',
    'portal.web.tamiin.nhia.enrollees-management/gifship',

      ...buildMany(ROLES.HMO, 'beneficiary', [
    'gifship-enrollee/gifship-enrollee-individual',
    'gifship-enrollee/gifship-enrollee-family',
    'gifship-enrollee/gifship-enrollee-group',
  ], ACTIONS.view),
   ...buildMany(ROLES.NHIA, 'beneficiary', [
    'gifship-enrollee/gifship-enrollee-individual',
    'gifship-enrollee/gifship-enrollee-family',
    'gifship-enrollee/gifship-enrollee-group',
  ], ACTIONS.view),
  ],
  SELF_ENROLLMENT: [
    'portal.web.tamiin.hmo.enrollees-management/self-enrollment',
    'portal.web.tamiin.hmo.beneficiary/self-enrollee/view',

    'portal.web.tamiin.nhia.enrollees-management/self-enrollment',
    'portal.web.tamiin.nhia.beneficiary/self-enrollee/view',
  ],
  INFORMAL: [
    'portal.web.tamiin.hmo.enrollees-management/informal',
    'portal.web.tamiin.nhia.enrollees-management/informal',
     // ========================
  // INFORMAL ENROLLEE
  // ========================
  ...buildMany(ROLES.HMO, 'beneficiary', [
    'informal-enrollee/informal-enrollee-principal',
    'informal-enrollee/informal-enrollee-dependent',
  ], ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'beneficiary', [
    'informal-enrollee/informal-enrollee-principal',
    'informal-enrollee/informal-enrollee-dependent',
  ], ACTIONS.view),
  ],
  CLAIMS: [
    'portal.web.tamiin.hmo.claims/claims-document-review',
    'portal.web.tamiin.hmo.claims/ai-claim-vetting',
    'portal.web.tamiin.hmo.claims/claims-review-validation',
    'portal.web.tamiin.hmo.claims/claims-adjudication',
    'portal.web.tamiin.hmo.claims/claims-report-analytics',
    'portal.web.tamiin.hmo.claims/claims-pre-authorizations',
    'portal.web.tamiin.hmo.claims/claims-inbox',
    'portal.web.tamiin.hmo.claims/claims-payments',
    'portal.web.tamiin.insuree.claims-management/my-claims',
    'portal.web.tamiin.provider.claims-management',
    'portal.web.tamiin.payer.claims-utilization/claims-utilization',

      `portal.web.tamiin.${ROLES.NHIA}.claims`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-payments`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-report-analytics`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-review-validation`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-adjudication`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/ai-claim-vetting`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-pre-authorizations`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-inbox`,
  `portal.web.tamiin.${ROLES.NHIA}.claims/claims-document-review`,

    ...buildMany(ROLES.NHIA, 'claims', [
    'claims-management',
  ], [
    'view',
  ]),
    ...buildMany(ROLES.NHIA, 'claims', [
    'claims-document-review',
  ], [
    'view',
    'link-to-claim',
    'audit',
    'export-documents',
    'flag-for-fraud-check',
    'reject-document',
    'verify-document',
    'upload-missing-documents',
  ]),
    // ========================
  // CLAIMS REVIEW VALIDATION
  // ========================
  ...buildMany(ROLES.NHIA, 'claims', [
    'claims-review-validation',
  ], [
    'view',
    'send-to-adjudication',
    'reopen',
    'escalate',
    'approve-for-adjudication',
    'reject',
    'partial-approval',
    'return-to-new',
  ]),

  // ========================
  // CLAIMS ADJUDICATION
  // ========================
  ...buildMany(ROLES.NHIA, 'claims', [
    'claims-adjudication',
  ], [
    'view',
    'reject',
    'make-payment',
  ]),

  // ========================
  // CLAIMS REPORT ANALYTICS
  // ========================
  ...buildMany(ROLES.NHIA, 'claims', [
    'claims-report-analytics',
  ], [
    'generate-report',
    'drill-down',
    'fraud-flagging',
    'schedule-report',
  ]),

  // ========================
  // AI CLAIMS VETTING
  // ========================
  ...buildMany(ROLES.NHIA, 'claims', [
    'ai-claims-vetting',
  ], [
    'view',
    'audit',
    'run-vetting',
    'reject',
    'assign-reviewer',
  ]),
  ],
  CLAIMS_DOCUMENT_REVIEW: [
    'portal.web.tamiin.hmo.claims/claims-document-review',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-document-review`,

     ...buildMany(ROLES.NHIA, 'claims', [
    'claims-document-review',
  ], [
    'view',
    'link-to-claim',
    'audit',
    'export-documents',
    'flag-for-fraud-check',
    'reject-document',
    'verify-document',
    'upload-missing-documents',
  ]),
  ],
  AI_CLAIM_VETTING: ['portal.web.tamiin.hmo.claims/ai-claim-vetting',
    `portal.web.tamiin.${ROLES.NHIA}.claims/ai-claim-vetting`,

    ...buildMany(ROLES.NHIA, 'claims', [
    'ai-claims-vetting',
  ], [
    'view',
    'audit',
    'run-vetting',
    'reject',
    'assign-reviewer',
  ]),
  ],
  CLAIMS_REVIEW_VALIDATION: [
    'portal.web.tamiin.hmo.claims/claims-review-validation',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-review-validation`,
  ...buildMany(ROLES.NHIA, 'claims', [
    'claims-review-validation',
  ], [
    'view',
  ]),
  ],
  CLAIMS_ADJUDICATION: ['portal.web.tamiin.hmo.claims/claims-adjudication',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-adjudication`,
  ...buildMany(ROLES.NHIA, 'claims', [
    'claims-adjudication',
  ], [
    'view',
  ]),
  ],
  CLAIMS_REPORT_ANALYTICS: [
    'portal.web.tamiin.hmo.claims/claims-report-analytics',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-report-analytics`,
  ...buildMany(ROLES.NHIA, 'claims', [
    'claims-report-analytics',
  ], [
    'view',
  ]),
  ],
  CLAIMS_PRE_AUTHORIZATIONS: [
    'portal.web.tamiin.hmo.claims/claims-pre-authorizations',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-pre-authorizations`,

    ...buildMany(ROLES.NHIA, 'claims', [
    'claims-pre-authorizations',
  ], [
    'view',
  ]),
  ],
  CLAIMS_INBOX: ['portal.web.tamiin.hmo.claims/claims-inbox',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-inbox`,

    ...buildMany(ROLES.NHIA, 'claims', [  
    'claims-inbox',
  ], [
    'view',
  ]),
  ],
  CLAIMS_PAYMENTS: ['portal.web.tamiin.hmo.claims/claims-payments',
    `portal.web.tamiin.${ROLES.NHIA}.claims/claims-payments`,

    ...buildMany(ROLES.NHIA, 'claims', [
    'claims-payments',
  ], [
    'view',
  ]),
  ],

  HMO_MANAGEMENT: [
    'portal.web.tamiin.insuree.hmo-management/my-hmos',
    'portal.web.tamiin.super_admin.hmo',
    'portal.web.tamiin.nhia.hmo',
  ],

  REFERRAL: [
    'portal.web.tamiin.hmo.referral/referral-workbench',
    'portal.web.tamiin.hmo.referral/referral-requests',
    'portal.web.tamiin.hmo.referral/auth-code-manager',
    'portal.web.tamiin.provider.referral/referral-workbench',
    'portal.web.tamiin.provider.referral/auth-code-manager',
    'portal.web.tamiin.provider.referral/referral-requests',
  ],
  REFERRAL_WORKBENCH: [
    'portal.web.tamiin.hmo.referral/referral-workbench',
    'portal.web.tamiin.provider.referral/referral-workbench',
  ],
  AUTH_CODE_MANAGER: [
    'portal.web.tamiin.hmo.referral/auth-code-manager',
    'portal.web.tamiin.provider.referral/auth-code-manager',
  ],
  REFERRAL_REQUESTS: [
    'portal.web.tamiin.hmo.referral/referral-requests',
    'portal.web.tamiin.provider.referral/referral-requests',
  ],

  PROVIDER_MANAGEMENT: [
    'portal.web.tamiin.hmo.provider-management',
    'portal.web.tamiin.super_admin.provider-management',
    'portal.web.tamiin.nhia.provider-management',


    ...buildMany(ROLES.HMO, 'provider', [
  'provider-management',
  'accreditation'
], ['view']),
 ...buildMany(ROLES.NHIA, 'provider', [
  'provider-management',
  'accreditation'
], ['view']),
  ],

  POLICY_MANAGEMENT: [
    'portal.web.tamiin.hmo.policy-management/program/programs',
    'portal.web.tamiin.hmo.policy-management/catalog/packages',
    'portal.web.tamiin.hmo.policy-management/catalog/formulary',
    'portal.web.tamiin.hmo.policy-management/catalog/services',
    
    `portal.web.tamiin.${ROLES.NHIA}.policy-management`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/program-catalog`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/program/programs`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/services`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/packages`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/formulary`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/pricing`,

    'portal.web.tamiin.insuree.policy-management/my-policies',
    'portal.web.tamiin.insuree.dashboard',

     // ========================
  // POLICY - CATALOG
  // ========================
  ...build(ROLES.HMO, 'policy', 'catalog/catalog-hbp', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'catalog/catalog-services', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'catalog/catalog-drug', ACTIONS.view),
    ...buildMany(ROLES.NHIA, 'policy', [
    'catalog/catalog-services',
  ], [
    'view',
    'create',
    'delete',
  ]),
   ...buildMany(ROLES.NHIA, 'policy', [
    'catalog/catalog-hbp',
  ], [
    'view',
    'create',
    'edit',
    'view-audit-log',
  ]),
...buildMany(ROLES.NHIA, 'policy', [
    'catalog/catalog-drug',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
  // ========================
  // POLICY - PROGRAM
  // ========================
  ...build(ROLES.HMO, 'policy', 'program/plans', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'program/programmes', ACTIONS.view),

   ...buildMany(ROLES.NHIA, 'policy', [
    'program/programmes',
  ], [
    'view',
    'create',
    'edit',
  ]),
  ...buildMany(ROLES.NHIA, 'policy', [
    'program/plans',
  ], [
    'view',
    'create',
    'edit',
    'deactivate',
  ]),

  // ========================
  // POLICY - PRICING
  // ========================
  ...build(ROLES.HMO, 'policy', 'pricing/pricing-payments', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'pricing/pricing-capitations', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'pricing/pricing-premium-schemas', ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'policy', [
    'pricing/pricing-capitations',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
   ...buildMany(ROLES.NHIA, 'policy', [
    'pricing/pricing-premium-schemas',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
  ...buildMany(ROLES.NHIA, 'policy', [
    'pricing/pricing-payments',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),

  ],
  PROGRAMS: [
    'portal.web.tamiin.hmo.policy-management/program/programs',
`portal.web.tamiin.${ROLES.NHIA}.policy-management/program-catalog`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/program/programs`,
    
   
 // ========================
  // POLICY - PROGRAM
  // ========================
  ...build(ROLES.HMO, 'policy', 'program/plans', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'program/programmes', ACTIONS.view),
   ...buildMany(ROLES.NHIA, 'policy', [
    'program/programmes',
  ], [
    'view',
    'create',
    'edit',
  ]),
  ...buildMany(ROLES.NHIA, 'policy', [
    'program/plans',
  ], [
    'view',
    'create',
    'edit',
    'deactivate',
  ]),
  ],
  CATALOG: [
    'portal.web.tamiin.hmo.policy-management/catalog/packages',
    'portal.web.tamiin.hmo.policy-management/catalog/formulary',
    'portal.web.tamiin.hmo.policy-management/catalog/services',
`portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/services`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/packages`,
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/formulary`,

      ...build(ROLES.HMO, 'policy', 'catalog/catalog-hbp', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'catalog/catalog-services', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'catalog/catalog-drug', ACTIONS.view),
     ...buildMany(ROLES.NHIA, 'policy', [
    'catalog/catalog-services',
  ], [
    'view',
    'create',
    'delete',
  ]),
   ...buildMany(ROLES.NHIA, 'policy', [
    'catalog/catalog-hbp',
  ], [
    'view',
    'create',
    'edit',
    'view-audit-log',
  ]),
...buildMany(ROLES.NHIA, 'policy', [
    'catalog/catalog-drug',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
  ],
  PACKAGES: [
    'portal.web.tamiin.hmo.policy-management/catalog/packages',
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/packages`,
    
    
  ],
  FORMULARY: ['portal.web.tamiin.hmo.policy-management/catalog/formulary',
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/formulary`,

  ],

  SERVICES: ['portal.web.tamiin.hmo.policy-management/catalog/services',
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/catalog/services`,

  ],
  PRICING: [
    'portal.web.tamiin.hmo.policy-management/pricing',
  `portal.web.tamiin.${ROLES.NHIA}.policy-management/pricing`,


      // ========================
  // POLICY - PRICING
  // ========================
  ...build(ROLES.HMO, 'policy', 'pricing/pricing-payments', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'pricing/pricing-capitations', ACTIONS.view),
  ...build(ROLES.HMO, 'policy', 'pricing/pricing-premium-schemas', ACTIONS.view),
  ...buildMany(ROLES.NHIA, 'policy', [
    'pricing/pricing-capitations',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
   ...buildMany(ROLES.NHIA, 'policy', [
    'pricing/pricing-premium-schemas',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
  ...buildMany(ROLES.NHIA, 'policy', [
    'pricing/pricing-payments',
  ], [
    'view',
    'create',
    'edit',
    'delete',
  ]),
],
  REPORT: [
    'portal.web.tamiin.insuree.report/my-reports',
    'portal.web.tamiin.provider.report',
    'portal.web.tamiin.hmo.report',
    'portal.web.tamiin.payer.report',
  ],

  AUDIT: [
    'portal.web.tamiin.super_admin.audit',
    'portal.web.tamiin.hmo.audit',
    'portal.web.tamiin.provider.audit',
  ],
  EMPLOYER_GROUP_MANAGEMENT: [
    'portal.web.tamiin.hmo.employer-group',
    'portal.web.tamiin.nhia.employer-group',
    'portal.web.tamiin.nhia.employer-group/view'
  ],
  EMPLOYEE_MANAGEMENT: [
    'portal.web.tamiin.payer.employer-group-management/employee-management',
  ],
  DEPENDANT_MANAGEMENT: [
    'portal.web.tamiin.payer.employer-group-management/dependant-management',
  ],
  PROGRAMS_PROVIDERS: [
    'portal.web.tamiin.payer.employer-group-management/programs-providers',
  ],
  DOCUMENTS_MANAGEMENT: [
    'portal.web.tamiin.payer.employer-group-management/documents',
    'portal.web.tamiin.provider.employer-group/documents',
  ],

  ENCOUNTER_MANAGEMENT: [
    'portal.web.tamiin.provider.encounter-management',
    'portal.web.tamiin.hmo.encounter-management',

    `portal.web.tamiin.${ROLES.NHIA}.encounter-management`,

  ],
  SUPPORT_CENTER: ['portal.web.tamiin.insuree.support-center/support-center'],
};
